import { AlertCircle, Image as ImageIcon, Loader2, MessageSquare, Send } from 'lucide-react'
import MentionTextarea from '../ui/MentionTextarea'
import CardCommentItem from './CardCommentItem'
import { getInitials } from './cardDetailUtils'

export default function CardCommentsTab({
    t,
    profile,
    comments,
    attachments,
    commentReactions,
    currentUserId,
    commentImageInputRef,
    handleCommentImageUpload,
    commentText,
    setCommentText,
    companyMembers,
    submittingComment,
    uploadingFile,
    handleAddComment,
    commentError,
    editingCommentId,
    editingCommentText,
    setEditingCommentId,
    setEditingCommentText,
    updateComment,
    removeComment,
    showAchievement,
    openLightbox,
    setPreviewFile,
    handleToggleCommentReaction,
    replyingTo,
    setReplyingTo,
    replyText,
    setReplyText,
    replySubmitting,
    replyImageInputRef,
    handleAddReply,
}) {
    const rootComments = comments.filter((comment) => !comment.parent_comment_id)

    return (
        <div>
            <div className="comment-input-row">
                <div className="comment-avatar comment-avatar-self">
                    {getInitials(profile?.full_name)}
                </div>
                <div className="comment-input-wrapper">
                    <input
                        ref={commentImageInputRef}
                        type="file"
                        accept="image/*"
                        multiple
                        className="sr-only"
                        onChange={async (event) => {
                            await handleCommentImageUpload(event.target.files)
                            event.target.value = ''
                        }}
                    />
                    <MentionTextarea
                        value={commentText}
                        onChange={setCommentText}
                        onSubmit={handleAddComment}
                        members={companyMembers || []}
                        files={attachments || []}
                        placeholder={t('card.comments.placeholder')}
                        disabled={submittingComment}
                    />
                    <button
                        type="button"
                        className="comment-image-button"
                        onClick={() => commentImageInputRef.current?.click()}
                        disabled={uploadingFile || submittingComment}
                        title="Adauga poza"
                        aria-label="Adauga poza"
                    >
                        {uploadingFile ? <Loader2 size={14} className="spin" /> : <ImageIcon size={14} />}
                    </button>
                    <button
                        className="comment-send-button"
                        onClick={handleAddComment}
                        disabled={!commentText.trim() || submittingComment}
                    >
                        <Send size={14} />
                    </button>
                </div>
            </div>
            {commentError && (
                <div className="date-error cd-comment-error">
                    <AlertCircle size={13} /> {commentError}
                </div>
            )}

            <div className="comment-list">
                {rootComments.map((comment) => (
                    <CardCommentItem
                        key={comment.id}
                        t={t}
                        comment={comment}
                        comments={comments}
                        attachments={attachments}
                        commentReactions={commentReactions}
                        currentUserId={currentUserId}
                        editingCommentId={editingCommentId}
                        editingCommentText={editingCommentText}
                        setEditingCommentId={setEditingCommentId}
                        setEditingCommentText={setEditingCommentText}
                        updateComment={updateComment}
                        removeComment={removeComment}
                        showAchievement={showAchievement}
                        openLightbox={openLightbox}
                        setPreviewFile={setPreviewFile}
                        handleToggleCommentReaction={handleToggleCommentReaction}
                        replyingTo={replyingTo}
                        setReplyingTo={setReplyingTo}
                        replyText={replyText}
                        setReplyText={setReplyText}
                        replySubmitting={replySubmitting}
                        replyImageInputRef={replyImageInputRef}
                        handleCommentImageUpload={handleCommentImageUpload}
                        handleAddReply={handleAddReply}
                        companyMembers={companyMembers}
                        uploadingFile={uploadingFile}
                    />
                ))}
                {comments.length === 0 && (
                    <div className="card-empty-tab">
                        <MessageSquare size={32} />
                        <p>{t('card.comments.empty')}</p>
                    </div>
                )}
            </div>
        </div>
    )
}
